import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'पेज नहीं मिला',
  title: 'हमें वह पेज नहीं मिला',
  body: 'हो सकता है लिंक पुराना हो गया हो, या पेज हटा दिया गया हो। हमें बताइए कि आप क्या ढूँढ रहे हैं, हम उसे ढूँढ देंगे।',
  suggestionsTitle: 'शायद आप यह ढूँढ रहे हैं',
  bestMatchTitle: 'क्या आपका मतलब था',
  prefillHint: 'आपने जो पता खोला था, उससे पहले से भरा गया',
  goHome: 'होम',
  browseAll: 'सभी श्रेणियाँ',
  reportBrokenLink: 'टूटे लिंक की रिपोर्ट करें',
  noticeTitle: 'वह पेज उपलब्ध नहीं है',
  noticeSearching: 'उसकी जगह {query} खोजा जा रहा है…',
  noticePrefilled: 'नीचे {query} खोजें, या हमें बताइए कि आप क्या ढूँढ रहे हैं।',
  errorTitle: 'कुछ गड़बड़ हो गई',
  errorBody: 'हम यह पेज लोड नहीं कर सके। पुनः प्रयास करें, या जो चाहिए उसे नीचे खोजें।',
  retry: 'पुनः प्रयास करें',
  streamLostTitle: 'हम यह पेज पूरा नहीं कर सके',
  streamLostBody: 'पेज सेव होने से पहले ही खोज रुक गई। इसे फिर से शुरू करें, हम आपके ही शब्दों से दोबारा शुरुआत करेंगे।',
  relaunch: 'फिर से खोजें',
};
